import type { ButtonHTMLAttributes, ReactNode } from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger'
  size?: 'small' | 'medium' | 'large'
  children: ReactNode
}

const Button = ({
  variant = 'primary',
  size = 'medium',
  children,
  className = '',
  ...props
}: ButtonProps) => {
  const baseStyles = 'rounded-lg font-light tracking-wide transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed active:scale-95'

  const variants = {
    primary: 'bg-primary text-white hover:bg-primary-light shadow-card hover:shadow-elevated',
    secondary: 'bg-neutral-100 text-primary border-2 border-neutral-300 hover:bg-neutral-200 hover:border-neutral-400',
    danger: 'bg-neutral-800 text-white hover:bg-neutral-900',
  }

  const sizes = {
    small: 'px-6 py-3 text-sm min-h-[44px]',
    medium: 'px-8 py-4 text-base min-h-[52px]',
    large: 'px-10 py-5 text-lg min-h-[60px]',
  }

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button
